module.exports = __webpack_public_path__ + "static/media/warehouse.5ee55666.png";